import { render, staticRenderFns } from "./procto-hidden-camera.vue?vue&type=template&id=6ae2c6ea"
import script from "./procto-hidden-camera.vue?vue&type=script&lang=js"
export * from "./procto-hidden-camera.vue?vue&type=script&lang=js"
import style0 from "./procto-hidden-camera.vue?vue&type=style&index=0&id=6ae2c6ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports